import React, { useEffect, useRef, useState } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { apiErrorMessage } from "../../helper/apiError";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Button,
  CircularProgress,
  FormGroup,
  Grid,
  IconButton,
  TextField,
  Typography,
  createSvgIcon,
  styled,
  Paper,
  Stack,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import OutlinedTextAreaField from "../../component/inputfiled/OutlinedTextedArea";
import AddIcon from "@mui/icons-material/Add";
import * as Yup from "yup";
import MyDatePicker from "../../component/datepicker/OutlinedDatepicker";
import dayjs from "dayjs";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Calendar from "../../Icon/Calendar";
import CustomButton from "../../component/button/button";
import Previews from "../../component/dropzone/Mydropzone";
import MyLogoDropzone from "../../component/dropzone/LogoDropzone";
import CustomOutlinedSelect from "../../component/select field/OutlinedSelectField";
import CustomDataTable from "../../component/datatable/DataTable";
import Mylogodropzone from "../../component/dropzone/Mylogodropzone";
import CustomSelect from "../../component/select field/OutlinedSelectField";
import { GetUniversityAction } from "../../Redux/action/SettingAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  CreateCatalogService,
  EditCatalogService,
} from "../../Redux/service/SettingService";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { UploadFileService } from "../../Redux/service/FileService";
import { createGlobalNotificationAPI } from "../../Redux/service/notificationService";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { Editor } from "react-draft-wysiwyg";
import {
  convertToRaw,
  convertFromHTML,
  ContentState,
  EditorState,
} from "draft-js";

const NoPaddingGridItem = styled(Grid)({
  paddingTop: "0px !important",
});

const selectOptions = [
  { value: 10, label: "Option 1" },
  { value: 20, label: "Option 2" },
  { value: 30, label: "Option 3" },
];
const AddNotificationPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const childRef = useRef(null);

  const { id } = useParams();
  const [b_description, setB_Description] = useState();
  const [editorState, setEditorState] = useState("");

  const [Edit, setEdit] = useState(id ? true : false);

  const [prefieldData, setPrefieldData] = useState();

  const [Universitylist, setUniversitylist] = useState([]);
  const [formLoading, setFormLoading] = useState(false);

  const EditCatalogdataState = useSelector(
    (state) => state.setting?.catalog?.data?.data
  );
  //(EditCatalogdataState);
  useEffect(() => {
    setPrefieldData(
      EditCatalogdataState?.filter((data) => data._id === id)?.[0]
    );
  }, [Edit, EditCatalogdataState, id]);

  const UniversitylistState = useSelector(
    (state) => state.setting?.university?.data?.universities
  );

  useEffect(() => {
    let data = {
      page: 1,
      limit: 0,
    };
    dispatch(GetUniversityAction(data));
  }, []);

  useEffect(() => {
    const updatedData = UniversitylistState?.map(({ name, ...rest }) => ({
      title: name,
      ...rest,
    }));
    setUniversitylist(updatedData);
  }, [UniversitylistState]);

  const validationSchema = Yup.object({
    text: Yup.string().required("Notification Text is required"),
    title: Yup.string().required("Notification Title is required"),
  });

  if (!prefieldData && Edit) {
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <CircularProgress color="inherit" />
      </div>
    ); // You can replace this with a loading spinner
  }

  return (
    <>
      <div className="d-flex align-items-center">
        <Typography
          fontFamily={FontFamily.Poppins}
          fontWeight={fontWeight.W600}
          fontSize={fontSize.h2.small}
        >
          Notification
        </Typography>
        <Typography
          className="px-2 pt-1"
          fontFamily={FontFamily.Poppins}
          fontSize={fontSize.h4.medium}
          fontWeight={fontWeight.W300}
          color={ThemeColor.GREY}
        >
          {!Edit ? "Create" : "Edit"} notification
        </Typography>
      </div>
      <div className="container">
        <Formik
          initialValues={{
            title: "",
            text: "",
            images: [],
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, { ressetForm }) => {
            setFormLoading(true);
            //("Form data:", values);
            if (values.images.length > 0) {
              values["attachmentUrl"] = [values?.images?.[0]?.url];
            }
            delete values.images;

            // console.log(values);
            // return;
            await createGlobalNotificationAPI(values)
              .then((res) => {
                if (res.status === 200) {
                  // //(res);
                  setFormLoading(false);

                  dispatch(showSnackbar(res.data.message, "success"));
                  navigate("/CAE/AllNotification");
                  ressetForm();
                }
              })
              .catch((e) => {
                setFormLoading(false);
                dispatch(showSnackbar(apiErrorMessage(e), "error"));
              });
          }}
        >
          {({
            values,
            errors,
            handleBlur,
            handleChange,
            touched,
            handleSubmit,
            setFieldValue,
            resetForm,
          }) => (
            <Form
              className="d-flex justify-content-center"
              onSubmit={handleSubmit}
              style={{ width: "100%", marginTop: "24px" }}
            >
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 3, md: 5 },
                  background: "#FFFFFF",
                  border: "1px solid #E2E8F0",
                  borderRadius: "16px",
                  boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)",
                  width: { xs: "100%", md: "80%" },
                }}
              >
                <Typography
                  align="left"
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W700}
                  fontSize="1.35rem"
                  color={ThemeColor.NAVYBLUE}
                  sx={{ borderBottom: "1px solid #E2E8F0", pb: 2, mb: 3 }}
                >
                  {!Edit ? "Add" : "Edit"} Global Notification
                </Typography>

                <Stack spacing={3}>
                  {/* Title */}
                  <Box>
                    <Typography
                      fontFamily={FontFamily.Poppins}
                      fontSize="0.875rem"
                      fontWeight={600}
                      color="#475569"
                      sx={{ mb: 1 }}
                    >
                      Notification Title
                    </Typography>
                    <OutlinedInputField
                      value={values.title}
                      name="title"
                      onChange={handleChange}
                      placeholder="Enter title"
                      fullWidth={true}
                      helperText={
                        errors.title && touched.title ? (
                          <Typography
                            color={ThemeColor.RED}
                            fontSize="0.75rem"
                            fontFamily={FontFamily.Lato}
                            fontWeight={500}
                            sx={{ mt: 0.5 }}
                          >
                            {errors.title}
                          </Typography>
                        ) : null
                      }
                    />
                  </Box>

                  {/* Text Editor */}
                  <Box>
                    <Typography
                      fontFamily={FontFamily.Poppins}
                      fontSize="0.875rem"
                      fontWeight={600}
                      color="#475569"
                      sx={{ mb: 1 }}
                    >
                      Notification Text
                    </Typography>
                    <Box
                      sx={{
                        border: "1px solid #E2E8F0",
                        borderRadius: "10px",
                        overflow: "hidden",
                        backgroundColor: "#F8FAFC",
                        transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                        "&:focus-within": {
                          borderColor: ThemeColor.LIGHTPURPLE,
                          boxShadow: `0 0 0 3px ${ThemeColor.LIGHTPURPLE}15`,
                          backgroundColor: "#FFFFFF",
                        },
                        "& .rdw-editor-toolbar": {
                          border: "none",
                          borderBottom: "1px solid #E2E8F0",
                          background: "#F1F5F9",
                          p: "8px 12px",
                          m: 0
                        },
                        "& .rdw-editor-main": {
                          padding: "16px",
                          minHeight: "180px",
                          maxHeight: "350px",
                          overflowY: "auto",
                          backgroundColor: "inherit",
                          fontSize: "0.95rem",
                          fontFamily: FontFamily.Lato
                        }
                      }}
                    >
                      <Editor
                        editorState={editorState}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        placeholder="Enter notification text"
                        onEditorStateChange={(e) => setEditorState(e)}
                        onChange={(e) => {
                          const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
                          setB_Description(html);
                          setFieldValue("text", html);
                        }}
                      />
                    </Box>
                    {errors.text && touched.text && (
                      <Typography
                        color={ThemeColor.RED}
                        fontSize="0.75rem"
                        fontFamily={FontFamily.Lato}
                        fontWeight={500}
                        sx={{ mt: 0.5 }}
                      >
                        {errors.text}
                      </Typography>
                    )}
                  </Box>

                  {/* Attachment */}
                  <Box>
                    <Typography
                      fontFamily={FontFamily.Poppins}
                      fontSize="0.875rem"
                      fontWeight={600}
                      color="#475569"
                      sx={{ mb: 1 }}
                    >
                      Attachment (Optional)
                    </Typography>
                    <Previews
                      deleteShow={true}
                      mainText="Upload Attachment"
                      text="Any type of file can be selected."
                      ref={childRef}
                      initialValue={values?.images}
                      handleMydropzoneFile={(updatedFiles) => {
                        setFieldValue("images", updatedFiles);
                      }}
                    />
                    {errors.images && touched.images && (
                      <Typography
                        color={ThemeColor.RED}
                        fontSize="0.75rem"
                        fontFamily={FontFamily.Lato}
                        fontWeight={500}
                        sx={{ mt: 0.5 }}
                      >
                        {errors.images}
                      </Typography>
                    )}
                  </Box>

                  {/* Footer Action Buttons */}
                  <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 2 }}>
                    {Edit && (
                      <CustomButton
                        variant="outlined"
                        type="button"
                        onClick={() => {
                          if (childRef.current) {
                            childRef.current.someEditFunction();
                          }
                          resetForm();
                        }}
                        sx={{
                          borderColor: "#CBD5E1",
                          color: "#475569",
                          "&:hover": {
                            borderColor: "#94A3B8",
                            backgroundColor: "#F8FAFC"
                          }
                        }}
                      >
                        Revert
                      </CustomButton>
                    )}
                    <CustomButton
                      variant="outlined"
                      type="button"
                      onClick={() => navigate("/CAE/AllNotification")}
                      sx={{
                        borderColor: "#CBD5E1",
                        color: "#475569",
                        "&:hover": {
                          borderColor: "#94A3B8",
                          backgroundColor: "#F8FAFC"
                        }
                      }}
                    >
                      Cancel
                    </CustomButton>
                    <CustomButton
                      variant="contained"
                      type="submit"
                      backgroundColor={ThemeColor.PURPLE}
                      color={ThemeColor.WHITE}
                      loading={formLoading}
                    >
                      {!Edit ? "Save" : "Edit"} Notification
                    </CustomButton>
                  </Box>
                </Stack>
              </Paper>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

function AddNotification() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<AddNotificationPage />} />
    </div>
  );
}

export default AddNotification;
